import { useMutation, useQuery } from '@tanstack/react-query';
import { ERROR_DIALOG } from 'gcs-common/constants/errorDialogConstants';
import { useHandleQueryError } from 'gcs-common/helper/errorMessages';
import type { Parameters, RequestBody } from '../../../../../types/typeHelper';
import { useApiClient } from '../../client';
import { ConnectionsQueryKeys, getGetErpCustomerUsersQueryKey } from './connections-api-helpers';

interface UseGetErpCustomerUsersQueryProps {
  path: Parameters<'/admin/connections/{connection_id}/connection-members', 'get'>['path'];
}

export function useGetErpCustomerUsersQuery({ path }: UseGetErpCustomerUsersQueryProps) {
  const client = useApiClient();
  const handleQueryError = useHandleQueryError();
  return useQuery({
    queryKey: getGetErpCustomerUsersQueryKey(path),
    enabled: !!path.connection_id,
    queryFn: async () => {
      const { data, error } = await client.GET('/admin/connections/{connection_id}/connection-members', {
        params: {
          path,
        },
      });
      handleQueryError({
        errorDialog: ERROR_DIALOG.NONE,
        // @ts-expect-error mistatch between openapi-fetch error and backend error types
        error,
      });
      return data;
    },
  });
}

export function useUpdateErpCustomerUserMutation() {
  const client = useApiClient();
  return useMutation({
    mutationKey: [ConnectionsQueryKeys.UPDATE_ERP_CUSTOMER_USER],
    mutationFn: async ({
      path,
      body,
    }: {
      path: Parameters<'/admin/connections/{connection_id}/connection-members/{craftsman_id}', 'put'>['path'];
      body: RequestBody<'/admin/connections/{connection_id}/connection-members/{craftsman_id}', 'put'>;
    }) => {
      return client.PUT('/admin/connections/{connection_id}/connection-members/{craftsman_id}', {
        body,
        params: {
          path,
        },
      });
    },
  });
}
